import { HEAVY_METAL_TEST_ID } from "./bestDealSuggestion/bestDealConstants";

export function clearSessionStorage() {
  sessionStorage.removeItem("patient");
  sessionStorage.removeItem("deliveryMethod");
  sessionStorage.removeItem("sendEmail");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("sendDate");
  sessionStorage.removeItem("sendText");
  sessionStorage.removeItem("phone");
  sessionStorage.removeItem("paymentMethod");
}

export const countryRestrictList = [
  {name: "Brazil", code: "BR", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("br")},
  {name: "China", code: "CN", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("cn")},
  // {name: "Cayman Islands", code: "KY", shipTo: "No (❌)", returnTo: "No (❌)", img: "Cayman.svg"},
  {name: "Costa Rica", code: "CR", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("cr")},
  {name: "Denmark", code: "DK", shipTo: "⚠️ No Blood kit", returnTo: "⚠️ No Blood sample", img: changeFlagIcon("dk")},
  {name: "Egypt", code: "EG", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("eg")},
  {name: "Indonesia", code: "ID", shipTo: "Yes", returnTo: "⚠️ Please contact Vibrant support to obtain the control number before shipping the sample", img: changeFlagIcon("id")},
  {name: "Italy", code: "IT", shipTo: "No (❌)", returnTo: "Yes", img: changeFlagIcon("it")},
  {name: "Lebanon", code: "LB", shipTo: "Yes", returnTo: "FedEx service not available", img: changeFlagIcon("lb")},
  {name: "Malaysia", code: "MY", shipTo: "Yes", returnTo: "DHL only", img: changeFlagIcon("my")},
  {name: "Mexico", code: "MX", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("mx")},
  {name: "Nigeria", code: "NG", shipTo: "Yes", returnTo: "⚠️ Please contact Vibrant support to obtain the control number before shipping the sample", img: changeFlagIcon("ng")},
  {name: "Pakistan", code: "PK", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("pk")},
  {name: "Panama", code: "PA", shipTo: "Yes", returnTo: "FedEx service not available", img: changeFlagIcon("pa")},
  {name: "Peru", code: "PE", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("pe")},
  // {name: "Poland", code: "PL", shipTo: "No to some areas", returnTo: "Yes", img: "Poland.svg"},
  {name: "Qatar", code: "QA", shipTo: "Yes", returnTo: "⚠️ Please contact Vibrant support to obtain the control number before shipping the sample", img: changeFlagIcon("qa")},
  {name: "Russia", code: "RU", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("ru")},
  {name: "Serbia", code: "RS", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("rs")},
  {name: "Slovakia", code: "SK", shipTo: "⚠️ Cannot ship to patients", returnTo: "Yes", img: changeFlagIcon("sk")},
  // {name: "Slovenia", code: "SI", shipTo: "No (❌)", returnTo: "No (❌)", img: "Slovenia.svg"},
  {name: "South Africa", code: "ZA", shipTo: "⚠️ Cannot ship to patients", returnTo: "Yes", img: changeFlagIcon("za")},
  {name: "Spain", code: "ES", shipTo: "No (❌)", returnTo: "Yes", img: changeFlagIcon("es")},
  {name: "Sri Lanka", code: "LK", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("lk")},
  {name: "Turkey", code: "TR", shipTo: "Yes", returnTo: "No (❌)", img: changeFlagIcon("tr")},
  {name: "Vietnam", code: "VN", shipTo: "No (❌)", returnTo: "No (❌)", img: changeFlagIcon("vn")},
];

function changeFlagIcon(countryName) {
  return "https://hatscripts.github.io/circle-flags/flags/" + countryName + ".svg";
}


// convert height from feet and inch to inches
export function getHeightInInches(feet, inch) {
  return Number(feet) * 12 + Number(inch);
}

// convert height from inches to feet and inch
export function getHeightInFeetAndInch(inches) {
  let feet = Math.floor(Number(inches) / 12);
  let inch = Number(inches) % 12;
  return { feet, inch };
}

/**
 * Returns true if any of the discount's triggerItemIds are selected in testList (selectProp).
 */
function isTriggerSelected(discount, testList, selectProp) {
  if (!discount.triggerItemIds || !Array.isArray(discount.triggerItemIds)) {
    return false;
  }
  return discount.triggerItemIds.some(triggerId => {
    const triggerItem = testList.find(item => item.id === triggerId);
    return triggerItem && triggerItem[selectProp] === true;
  });
}

/**
 * Returns true if the item (test, panel, promo) contains the given triggerId.
 * Mirrors how getVwTestsPrice determines which items "contain" a test.
 */
function itemContainsTriggerId(item, triggerId) {
  if (!item || !triggerId) return false;
  if (["va", "vw"].includes(item.category)) {
    return item.id === triggerId;
  }
  if (item.category === "discountPanel" && item.bundleContent) {
    const idList = (item.bundleContent.packageList || []).map(p => p.packageId)
      .concat((item.bundleContent.testList || []).map(t => t.testId));
    return idList.includes(triggerId);
  }
  if (item.category === "customPanel") {
    const idList = (item.bundleItemList || []).map(c => c.itemId);
    return idList.includes(triggerId);
  }
  if (item.category === "xChooseY") {
    const ids = (item.selectedZoomerIdList || []).concat(item.selectedSupplementIdList || []);
    return ids.includes(triggerId);
  }
  if (item.category === "seasonalPromo" && item.testIdsInPromo) {
    const ids = item.testIdsInPromo instanceof Set ? [...item.testIdsInPromo] : item.testIdsInPromo;
    return ids.includes(triggerId);
  }
  return false;
}

/**
 * Total price of panels/tests that include any of the trigger test ids.
 * Used to compare with thresholdAmount: sum the price of every selected panel or test
 * that contains at least one trigger id. Excludes items with toBeOffline (like getVwTestsPrice) and
 * the item identified by excludeItemId (e.g. the test that has the conditional discount).
 *
 * @param {Array} itemList - Flat list of selected items (tests, discountPanel, customPanel, xChooseY, seasonalPromo). For shortcuts, expand to non-shortcut + itemsInSelectedShortcuts.
 * @param {number[]} triggerItemIds - Test ids that are triggers for the conditional discount
 * @param {number} [excludeItemId] - If provided, exclude from the sum any selected test with this id (the item that has the conditional discount)
 * @returns {number} - Total price of panels/tests that include a trigger test (for threshold comparison)
 */
export function getTriggerItemsPrice(itemList, triggerItemIds, excludeItemId) {
  if (!itemList || !Array.isArray(itemList) || !triggerItemIds || triggerItemIds.length === 0) {
    return 0;
  }
  let total = 0;
  for (const item of itemList) {
    if (item.toBeOffline) {
      continue;
    }
    if (excludeItemId && ["va", "vw"].includes(item.category) && item.id === excludeItemId) {
      continue;
    }
    if (triggerItemIds.some(triggerId => itemContainsTriggerId(item, triggerId)) && item.price) {
      total += item.price;
    }
  }
  return total;
}

/**
 * Applies conditional discounts to tests based on selected trigger items.
 * Handles both trigger-items-based and threshold-based discounts
 * For threshold-based: compares thresholdAmount with the total price of the selected trigger items; 
 * uses discountedPrice when trigger items total > thresholdAmount. 
 * For trigger-items-based: uses discountedPrice when trigger items are selected.
 * When multiple eligible discounts exist, applies the minimum effective price.
 *
 * conditionalDiscounts format from backend:
 * "conditionalDiscounts": [
 *   { "triggerItemIds": [823], "thresholdAmount": null, "discountedPrice": 100 },
 *   { "triggerItemIds": [823], "thresholdAmount": 199, "discountedPrice": 60 }
 * ]
 *
 * @param {Array} testList - Array of test objects
 * @param {string} selectProp - Property to check if a test is selected (e.g., "isSelect", "isSelectForShortcut")
 * @param {Array} [selectedItemList] - selected panels/tests; for shortcuts include itemsInSelectedShortcuts. Used to compare trigger total with thresholdAmount.
 * @returns {void}
 */
export function applyConditionalDiscounts(testList, selectProp, selectedItemList) {
  if (!testList || !Array.isArray(testList) || !selectProp) {
    return;
  }

  testList.forEach(item => {
    if (item.conditionalDiscounts) {
      const discounts = Array.isArray(item.conditionalDiscounts)
        ? item.conditionalDiscounts
        : [item.conditionalDiscounts];

      const eligibleDiscounts = discounts.filter(
        d => d.discountedPrice && isTriggerSelected(d, testList, selectProp)
      );

      if (eligibleDiscounts.length === 0) {
        if (item.originalPrice) {
          item.price = item.originalPrice;
        }
        return;
      }

      const originalPrice = item.originalPrice ?? Infinity;
      const effectivePrices = eligibleDiscounts.map(discount => {
        if (discount.thresholdAmount) {
          const triggerTotal = selectedItemList && Array.isArray(selectedItemList) && discount.triggerItemIds?.length
            ? getTriggerItemsPrice(selectedItemList, discount.triggerItemIds, item.id)
            : undefined;
          const meetsThreshold = triggerTotal && triggerTotal > discount.thresholdAmount;
          return meetsThreshold ? discount.discountedPrice : originalPrice;
        }
        return discount.discountedPrice;
      });
      item.price = Math.min(originalPrice, ...effectivePrices);
    }
  });
}


/**
 * Calculates the total price for selected VW tests
 * 
 * @param {Array} itemList - Array of selected items (tests, panels, promos, etc.)
 * @param {Array} vwTestList - Array of all available VW test objects for reference
 * @param {boolean} includeHeavyMetal - Whether to include heavy metal test in the calculation (default: false)
 * @returns {number} - Total price for VW tests and related items
 * 
 * This function calculates the price by summing:
 * 1. Selected VW tests (optionally excluding heavy metal based on includeHeavyMetal flag)
 * 2. Discount panels that contain VW tests
 * 3. Custom panels that contain VW tests
 * 4. X-choose-Y panels (e.g., 3-for-700, 5-for-1000)
 * 5. Seasonal promotions that include VW tests
 */
export function getVwTestsPrice(itemList, vwTestList, includeHeavyMetal = false) {
  let price = 0;
  
  // Calculate price for selected VW tests
  // Filter: include/exclude heavy metal based on includeHeavyMetal flag
  let vwTestFilter = includeHeavyMetal 
    ? (t => t.category === "vw" && !t.toBeOffline)
    : (t => t.id !== HEAVY_METAL_TEST_ID && t.category === "vw" && !t.toBeOffline);
  price += itemList.filter(vwTestFilter)
    .reduce((acc, t) => acc + t.price, 0);
  
  // Add price for discount panels that contain VW tests
  itemList.filter(item => item.category === "discountPanel" && !item.toBeOffline)
    .forEach(panel => {
      let idList = panel.bundleContent.packageList.map(p => p.packageId)
      .concat(panel.bundleContent.testList.map(t => t.testId));
      if (idList.some(id => vwTestList.map(t => t.id).includes(id)))
        price += panel.price;
    });
  
  // Add price for custom panels that contain VW tests
  itemList.filter(item => item.category === "customPanel")
    .forEach(panel => {
      if (panel.selectedXChooseYPanelList.length > 0)
        price += panel.price;
      else {
        let idList = panel.bundleItemList
          .filter(content => content.itemType !== "official bundle")
          .map(content => content.itemId);
        if (idList.some(id => vwTestList.map(t => t.id).includes(id)))
          price += panel.price;
      }
    });
  
  // Add price for selected x-choose-y panels (e.g., 3-for-700, 5-for-1000)
  price += itemList.filter(item => item.category === "xChooseY").reduce((acc, panel) => acc + panel.price, 0);
  
  // Add price for seasonal promotions that include VW tests
  itemList.filter(item => item.category === "seasonalPromo").forEach(promo => {
    if ([...promo.testIdsInPromo].some(id => vwTestList.map(t => t.id).includes(id))) {
      price += promo.price;
    }
  })
  
  return price;
}

// get total price for itemList
export function getItemsPrice(itemList) {
  let price = 0;
  itemList.forEach(item => {
    price += item.price;
  });
  return Number(price.toFixed(2));
}

export const fakePromo = [
  {
    "discountName": "OxidativeStress",
    "id": 824,
    "sampleTypeSets": {
      "blood": new Set(),
      "nonBlood": new Set(['Saliva', 'Urine']),
      "dryIce": new Set(),
    }
  },
  {
    "discountName": "TotalToxins",
    "id": 18261,
    "sampleTypeSets": {
      "blood": new Set(),
      "nonBlood": new Set(['Urine']),
      "dryIce": new Set(),
    }
  },
];


// background color, border color and text color for test sample type tags
export function processTestSampleTypeTagColor(typeName) {
  let colorObj = { backgroundColor: "", borderColor: "", color: ""};
  switch (typeName) {
    case "Serum":
    case "SR":
      colorObj.backgroundColor = "rgba(255,244,243,0.91)";
      colorObj.borderColor = "#DF4430";
      colorObj.color = "#DF4430";
      return colorObj;
    case "EDTA":
      colorObj.backgroundColor = "#EDFFE9";
      colorObj.borderColor = "#28B008";
      colorObj.color = "#28B008";
      return colorObj;
    case "Urine":
    case "UR":
    case "Urine UTI":
    case "Urinalysis":
      colorObj.backgroundColor = "#FFF4E0";
      colorObj.borderColor = "#E0961E";
      colorObj.color = "#E0961E";
      return colorObj;
    case "Plasma":
    case "PM":
      colorObj.backgroundColor = "#FBF4FF";
      colorObj.borderColor = "#8000D1";
      colorObj.color = "#8000D1";
      return colorObj;
    case "Genotype":
    case "GT":
      colorObj.backgroundColor = "#FFEAE0";
      colorObj.borderColor = "#E74E00";
      colorObj.color = "#E74E00";
      return colorObj;
    case "DNA":
      colorObj.backgroundColor = "rgba(40,148,118,0.14)";
      colorObj.borderColor = "#289476";
      colorObj.color = "#289476";
      return colorObj;
    case "DBS":
      colorObj.backgroundColor = "rgba(229, 42, 183, 0.10)";
      colorObj.borderColor = "#E52AB7";
      colorObj.color = "#E52AB7";
      return colorObj;
    case "Blood":
      colorObj.backgroundColor = "rgba(255,49,49,0.11)";
      colorObj.borderColor = "#FF3131";
      colorObj.color = "#FF3131";
      return colorObj;
    case "Shit":
    case "ST":
      colorObj.backgroundColor = "#EEE7C9";
      colorObj.borderColor = "#766003";
      colorObj.color = "#766003";
      return colorObj;
    case "Parasites":
    case "PS":
      colorObj.backgroundColor = "rgba(229,42,183,0.1)";
      colorObj.borderColor = "#E52AB7";
      colorObj.color = "#E52AB7";
      return colorObj;
    case "Stool":
    case "SL":
      colorObj.backgroundColor = "rgba(161,92,26,0.2)";
      colorObj.borderColor = "#A15C1A";
      colorObj.color = "#A15C1A";
      return colorObj;
    case "TES":
    case "Sodi Citra Plasma":
      colorObj.backgroundColor = "rgba(5,157,200,0.11)";
      colorObj.borderColor = "#059DC8";
      colorObj.color = "#059DC8";
      return colorObj;
    case "Saliva":
    case "SA":
      colorObj.backgroundColor = "rgba(40, 148, 118, 0.10)";
      colorObj.borderColor = "#289476";
      colorObj.color = "#289476";
      return colorObj;
    case "COVID":
    case "CO":
      colorObj.backgroundColor = "rgba(7,18,183,0.15)";
      colorObj.borderColor = "#0712B7";
      colorObj.color = "#0712B7";
      return colorObj;
    default: // for type N/A and others
      colorObj.backgroundColor = "#EDEDED";
      colorObj.borderColor = "#7B7B7B";
      colorObj.color = "#7B7B7B";
      return colorObj;
  }
}

// sample type name abbreviations
export function processNameAbbreviation(name) {
  switch(name) {
    case "Serum":
      return "SR";
    case "Urine":
      return "UR";
    case "Plasma":
      return "PM";
    case "Genotype":
      return "GT";
    case "Shit":
      return "ST";
    case "Parasites":
      return "PS";
    case "Stool":
      return "SL";
    case "Saliva":
      return "SA";
    case "COVID":
      return "CO";
    default:
      return name;
  }

}

export function processNameAbbreviationNew(name) {
  switch (name) {
    case "Serum":
      return "SR";
    case "Urine":
      return "UR";
    case "Plasma":
      return "PM";
    case "Genotype":
      return "GT";
    case "Shit":
      return "ST";
    case "Parasites":
      return "PS";
    case "Stool":
      return "SL";
    case "Saliva":
      return "SA";
    case "COVID":
      return "CO";
    case "Urine (4 Tubes)":
      return "UR4";
    case "Saliva (6 Tubes)":
      return "SA6";
    case "Blood":
      return "BD";
    case "Microtube":
      return "MT";
    default:
      return name;
  }
}